import React from "react";

import { Card } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const useStyles = makeStyles()(theme => ({
	ticketHeader: {
		display: "flex",
		backgroundColor: theme.palette.mode === "light" ? "#eee" : "#20252c",
		flex: "none",
	},
}));

const TicketHeader = ({ loading, children }) => {
	const { classes } = useStyles();

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card square className={classes.ticketHeader}>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
